const getPageType = function () {
  let pageType = "Unknown";
  document.body.classList.forEach(function (el) {
    if (el.includes("page-node-type-")) {
      pageType = el.replace("page-node-type-", "");
      return;
    }
  });
  switch (pageType) {
    case "home-page":
      return "Homepage";
    case "mdi-main-page":
      return "MDI Homepage";
    case "product-page-type-3":
      return "780G";
    default:
      return pageType;
  }
};

document.addEventListener("DOMContentLoaded", function () {
  if (null === window.dataLayer || undefined === window.dataLayer) {
    window.dataLayer = [];
  }

  // homepages GTM
  if (
    document.body.classList.contains("mdi-main-page") ||
    document.body.classList.contains("home-page")
  ) {
    // support links
    document.querySelectorAll(".support-menu-link").forEach(function (el) {
      el.addEventListener("click", function (e) {
        dataLayer.push({
          event: "gaEvent",
          eventCategory: "interest",
          eventAction: "click_link",
          eventLabel: el.getAttribute("data-gtmtarget"),
        });
      });
    });
    // social links
    document.querySelectorAll(".social-nav .nav-link").forEach(function (el) {
      el.addEventListener("click", function (e) {
        dataLayer.push({
          event: "gaEvent",
          eventCategory: "socialMedia",
          eventAction: "click_icon",
          eventLabel: el.getAttribute("data-gtmtarget"),
        });
      });
    });
    // footer contact links
    document.querySelectorAll(".contact-gtm .nav-link").forEach(function (el) {
      el.addEventListener("click", function (e) {
        dataLayer.push({
          event: "gaEvent",
          eventCategory: "interest",
          eventAction: "click_icon",
          eventLabel: "nav - Contact",
        });
      });
    });
    // back to top
    var gtmEl = document.getElementById("back-to-top");
    if (gtmEl) {
      gtmEl.addEventListener("click", function (e) {
        dataLayer.push({
          event: "gaEvent",
          eventCategory: "interest",
          eventAction: "click_link",
          eventLabel: "Back to top",
        });
      });
    }
    // chat bot (mutation observer is used because DOM changes via teneo script)
    // if (document.body.classList.contains("en-gb")) {
    //   const chatWrapperObserverFunc = function (muts) {
    //     muts.forEach(function (mut) {
    //       if (
    //         Array.from(mut.addedNodes).some(function (el) {
    //           return el.id === "chatBot";
    //         })
    //       ) {
    //         chatWrapperObserver.disconnect();

    //         const supportHandler = function () {
    //           dataLayer.push({
    //             event: "gaEvent",
    //             eventCategory: "contact",
    //             eventAction: "clickSupport",
    //             eventLabel: "supportAssistant",
    //           });
    //         };

    //         const botDiv = document.querySelector("#chatBot");
    //         if (botDiv) {
    //           const chatBtn = document.querySelector(".twc-launch-button");
    //           if (chatBtn) {
    //             chatBtn.addEventListener("click", supportHandler);
    //           }

    //           var chatObserver = new MutationObserver(function (mutations) {
    //             mutations.forEach(function (mutation) {
    //               if (!mutation.addedNodes) return;
    //               for (let i = 0; i < mutation.addedNodes.length; i++) {
    //                 let node = mutation.addedNodes[i];
    //                 if (
    //                   node.firstElementChild &&
    //                   node.firstElementChild.tagName === "BUTTON" &&
    //                   node.firstElementChild.className.includes(
    //                     "twc-launch-button"
    //                   )
    //                 )
    //                   node = node.firstElementChild;
    //                 if (
    //                   node.tagName === "BUTTON" &&
    //                   node.className.includes("twc-launch-button")
    //                 ) {
    //                   node.addEventListener("click", supportHandler);
    //                 }
    //               }
    //             });
    //           });
    //           chatObserver.observe(botDiv, {
    //             childList: true,
    //             subtree: true,
    //             attributes: false,
    //             characterData: false,
    //           });
    //         }
    //       }
    //     });
    //   };

    //   const chatWrapperObserver = new MutationObserver(chatWrapperObserverFunc);
    //   chatWrapperObserver.observe(document.body, {
    //     childList: true,
    //   });
    // }
    // search
    var searchInput = document.getElementById("search-block-form");
    if (searchInput) {
      searchInput.addEventListener("submit", function (e) {
        dataLayer.push({
          event: "gaEvent",
          eventCategory: "search",
          eventAction: getPageType(),
          eventLabel: document.querySelector("#search-block-form #edit-keys")
            .value,
        });
      });
    }
    // balloon challenge
    document
      .querySelectorAll(".balloon-challenge-gtm .mdt-image-slide-link")
      .forEach(function (el) {
        el.addEventListener("click", function (e) {
          dataLayer.push({
            event: "gaEvent",
            eventCategory: "interest",
            eventAction: "click_img",
            eventLabel: "#T1DBalloonChallenge",
          });
        });
      });
    // product cards
    document.querySelectorAll(".gtm-card-target").forEach(function (el) {
      el.addEventListener("click", function (e) {
        dataLayer.push({
          event: "gaEvent",
          eventCategory: "interest",
          eventAction: "click_cta",
          eventLabel: el.getAttribute("data-gtmtarget") + " - discover more",
        });
      });
    });
    // main menu
    document
      .querySelectorAll(".navbar-nav a.nav-link, .navbar-nav a.btn")
      .forEach(function (el) {
        el.addEventListener("click", function (e) {
          dataLayer.push({
            event: "gaEvent",
            eventCategory: "interest",
            eventAction: "click_menu",
            eventLabel: el.innerHTML,
          });
        });
      });
    // Scroll and click
    let reached75 = false;

    function scrollDataPush() {
      dataLayer.push({
        event: "gaEvent",
        eventCategory: "Home",
        eventAction: "engagement",
        eventLabel: "scrollAndTimeOrClicks",
      });
    }

    function scrollEvent(e) {
      const posY = window.scrollY ? window.scrollY : window.pageYOffset;
      if (
        parseInt(
          (posY / (document.body.clientHeight - window.innerHeight)) * 100
        ) > 74
      ) {
        reached75 = true;
        window.removeEventListener("click", clickEvent);
        window.addEventListener("click", clickEvent);
        window.removeEventListener("scroll", scrollEvent);
      }
    }

    function clickEvent(e) {
      scrollDataPush();
    }

    window.addEventListener("scroll", scrollEvent);

    // Finland doesn't need it
    if (!document.body.classList.contains("fi-FI")) {
      window.setTimeout(function () {
        if (reached75) window.removeEventListener("click", clickEvent);
        window.addEventListener("click", clickEvent);
      }, 60000);
    }
    //
  }

  // 780g without forms GTM
  const locales780g = ["fi-FI", "pl-PL", "es-ES", "en-ZA", "no-NO"];
  if (
    document.body.classList.contains("product-page-type-3") &&
    locales780g.some(function (el) {
      return document.body.classList.contains(el);
    })
  ) {
    const oneMinClicksHandler = function () {
      dataLayer.push({
        event: "oneMinClicks",
      });
    };
    const selectors780g = [
      "svg g g.components-pointer",
      ".btn-lg",
      ".mdt-accordeon button.btn-link",
      ".brand-block-controll a",
      ".nav.nav-tabs [data-toggle='tab']",
      ".paragraph-mdt-video",
    ];
    selectors780g.forEach(function (el) {
      document.querySelectorAll(el).forEach(function (q) {
        q.addEventListener("click", oneMinClicksHandler);
      });
    });

    // add mutation observer for hidden owl-carousel
    const hiddenCarousels = document.querySelectorAll(
      ".owl-carousel:not(.owl-loaded)"
    );
    hiddenCarousels.forEach(function (carousel) {
      const carouselObserver = new MutationObserver(function (mutations) {
        if (
          mutations.some(function (m) {
            return (
              !m.oldValue.includes("owl-loaded") &&
              m.target.classList.contains("owl-loaded")
            );
          })
        )
          carousel
            .querySelectorAll(".owl-prev,.owl-next")
            .forEach(function (q) {
              q.addEventListener("click", oneMinClicksHandler);
            });
      });
      carouselObserver.observe(carousel, {
        attributes: true,
        attributeOldValue: true,
        attributeFilter: ["class"],
      });
    });
  }

  // cookie accept event
  const localesCookiesClose = ["nl-NL", "de-DE"];
  if (
    localesCookiesClose.some(function (el) {
      return document.body.classList.contains(el);
    })
  ) {
    const gtmEls = document.querySelectorAll(
      ".agree-button.eu-cookie-compliance-default-button"
    );
    gtmEls.forEach(function (q) {
      q.addEventListener("click", function (e) {
        dataLayer.push({
          event: "cookieConsent",
          eventCategory: "Cookie Module",
          eventAction: "Accept all",
        });
      });
    });
  }
});
